var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-modal-wrapper"},[_c('modal',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('time-tracking-calendar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }